module.exports = __webpack_public_path__ + "static/media/responsibility-small1.ec49a1a5.jpg";